import React from "react";
import {
  VegaFlex,
  VegaIcon,
  VegaFont,
  VegaBox,
} from "@heartlandone/vega-react";

function ActivityParticipants({ currentCount, limitCount, registerNumberLimitType }) {
  return (
    <VegaFlex gap={"size-12"}>
      <VegaBox width="size-16" height="size-16">
        <VegaIcon
          icon="fal fa-users-viewfinder"
          size="size-16"
          color="text-secondary"
        ></VegaIcon>
      </VegaBox>
      <VegaFont color="text-secondary" variant="font-field-value-sm">
        Participants ({currentCount}{ registerNumberLimitType === 'Limited' ? `/${limitCount}` : ''})
      </VegaFont>
    </VegaFlex>
  );
}

export default ActivityParticipants;
